import { Box, Stack } from '@atgfr8/atg-ui-tailwind';
import { useParams } from '@solidjs/router';
import { AddressBookModel } from '@store/customers/customerDetails/addressBookTab';
import { PlaylistCheckIcon } from '@atgfr8/icons';

import AddressBookGrid from './AddressBookGrid';
import { addressBookTabStyle as classes } from './classes';

export const agGridCellStyle = {
  padding: '10px',
  'word-break': 'break-word',
  'white-space': 'normal',
  'line-height': '1.6 ',
  'align-items': 'center !important',
};

export const DefaultOrigin = (data: AddressBookModel) => {
  const statusIcon = data.isDefaultAddress && (
    <PlaylistCheckIcon class="text-[#15668f]" />
  );
  return (
    <Box class="flex gap-3">
      <span class={`${data.isDefaultAddress && 'font-semibold'}`}>
        {data.name} {statusIcon}
      </span>
    </Box>
  );
};

export const AddressColumn = (props: {
  val1: string | null;
  val2: string | null;
  val3?: string | null;
}) => {
  return (
    <Stack direction="column">
      <span>{props.val1}</span>
      <span>{props.val2}</span>
      <span>{props.val3}</span>
    </Stack>
  );
};

const AddressBookTab = () => {
  const params = useParams();

  return (
    <Box class={classes.container} backgroundColor="#E1ECF2">
      <AddressBookGrid customerId={Number(params.id)} type="Stops" />
    </Box>
  );
};

export default AddressBookTab;
